import Header from "./Header.jsx";
import {Suspense, useCallback, useEffect, useState} from "react";
import ApiRequester from "./ApiRequester.jsx";
import Button from "./component-assets/Button.jsx";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
    paginateData,
    calculateSendTime,
    formatDate,
    sortFunc,
    handleSubmitActions,
    getCurrentYear,
    formSuccess,
    showModal,
    formatDateIso,
    formCheck,
    convertHHMMtoSec,
    range,
    swapModal,
    actionAppearance, campusToGuid, checkAll, isBannerPresent, headerFilterFunc
} from "../libs.jsx";
import {toast, ToastContainer} from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import {Pagination} from "react-bootstrap";
import PaginationItems from "./component-assets/PaginationItems.jsx";
import Footer from "./Footer.jsx";
import PerPageModal from "./component-assets/PerPageModal.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import {v4 as uuidv4} from "uuid"
import TableBody from "./component-assets/TableBody.jsx";
import Navigation from "./Navigation.jsx";
import { getSession, setSession } from "../services/session";


const MaintenanceCloudReports = (props) => {

    let dData, headerData, csvHeaders, eventTypeHeaders;

    headerData = [
        {label: "Detected", key: "event_datetime_utc", align: "center", type: "datetime-utc"},
        {label: "Duration", key: "event_datetime_utc", align: "center", type: "duration"},
        {label: "Condition", key: "condition", align: "center"},
        {label: "Device / Serial", key: ["device_name", "manufacture_uuid"], align: "center",
            link: {enabled: true, type: "conditional-stack", conditionKey: "manufacture_id",
                condition: {
                    1: {linkto: "/profiles/inovonics", linkkey: "device_id"},
                    4: {linkto: "/profiles/palcare", linkkey: "device_id"}
                }}},
        {label: "Area", key: "area_name", align: "center",
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Resident", key: "resident_name", align: "center",
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}}
    ];

    csvHeaders = [
        {label: "Detected (UTC)", key: "event_datetime_utc"},
        {label: "Condition", key: "condition"},
        {label: "Device Name", key: "device_name"},
        {label: "Device Serial #", key: "manufacture_uuid"},
        {label: "Area", key: "area_name"},
        {label: "Resident", key: "resident_name"}
    ];

    if (getSession() != null) {
        dData = getSession();
    }

    let daysago = new Date().setDate(new Date().getDate());

    // Data Variables
    const [reportData, setReportData] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [summaryData, setSummaryData] = useState([]);
    const [freqData, setFreqData] = useState([]);
    const [csvUrl, setCSVUrl] = useState("");
    // Table Control Variables
    const [summaryRows, setSummaryRows] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [headerFilters, setHeaderFilters] = useState([]);
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter, setSorter] = useState({
        sortColumn: "event_datetime_utc",
        sortOrder: "asc"
    });
    // Page Variables
    const [campusId, setCampusId] = useState(dData.acnt);
    const [reportDisplay, setReportDisplay] = useState("");
    const [count, setCount] = useState(0);
    const [filterCount, setFilterCount] = useState(0);
    const [footer, setFooter] = useState(<div></div>);
    const [repType, setRepType] = useState("Detailed");
    const [scheduleable, setScheduleable] = useState(true);
    const [csvLink, setLink] = useState({
        filename: "maintenance_events.csv",
        headers: [],
        data: []
    });
    const [overLimit, setOverLimit] = useState(false);
    // Helper Control Variables
    const [status, setStatus] = useState("init");
    const [btnAvail, setBtnAvail] = useState(false);
    const [startDisplay, setStartDisplay] = useState("");
    const [endDisplay, setEndDisplay] = useState("");
    const [tabItem, setTabItem] = useState("event");
    const [tabCat, setTabCat] = useState("events");
    const [tmpPerPage, setTmpPerPage] = useState(dData.perPage);
    const [freqOptions, setFreqOptions] = useState([]);
    const [rangeName, setRangeName] = useState("Today");
    const [rangeId, setRangeId] = useState(1);
    // Header Variables
    const [csvButtonHTML, setCSVButtonHTML] = useState("");
    const [start, setStart] = useState(new Date(daysago));
    const [end, setEnd] = useState(new Date(daysago));

    // Backend Filter Holders For Selected Filters IDs
    const [areaFilterList, setAreaFilterList] = useState([]);
    const [areaGroupFilterList, setAreaGroupFilterList] = useState([]);
    const [areaTypeFilterList, setAreaTypeFilterList] = useState([]);
    const [devCatFilterList, setDevCatFilterList] = useState([]);
    const [resFilterList, setResFilterList] = useState([]);
    const [residentGroupFilterList, setResidentGroupFilterList] = useState([]);
    const [typeFilterList, setTypeFilterList] = useState([]);
    const [userFilterList, setUserFilterList] = useState([]);
    const [userGroupFilterList, setUserGroupFilterList] = useState([]);
    const [reasonFilterList, setReasonFilterList] = useState([]);
    // Backend Filter Holders For Selected Filters Labels
    const [areaFilterLabels, setAreaFilterLabels] = useState([]);
    const [areaGroupFilterLabels, setAreaGroupFilterLabels] = useState([]);
    const [areaTypeFilterLabels, setAreaTypeFilterLabels] = useState([]);
    const [devCatFilterLabels, setDevCatFilterLabels] = useState([]);
    const [resFilterLabels, setResFilterLabels] = useState([]);
    const [residentGroupFilterLabels, setResidentGroupFilterLabels] = useState([]);
    const [typeFilterLabels, setTypeFilterLabels] = useState([]);
    const [userFilterLabels, setUserFilterLabels] = useState([]);
    const [userGroupFilterLabels, setUserGroupFilterLabels] = useState([]);
    const [reasonFilterLabels, setReasonFilterLabels] = useState([]);
    // Modal for emails on schedules
    const [addCurEmails, setAddCurEmails] = useState([]);
    const [addNewEmails, setAddNewEmails] = useState([]);
    const [emailEntities, setEmailEntities] = useState([]);
    // Overlimit send email report storage variables, updated on run report.
    const [reportFilterTermsx, setReportFilterTermsx] = useState({});
    const [startDatex, setStartDatex] = useState("");
    const [endDatex, setEndDatex] = useState("");

    // Processes report origin data into active data, active data has filters applied removing data potentially.
    useEffect(() => {
        // front end filtering could be applied here taking reportData or summaryData, applying filter
        // while transferring to it's activeData counterpart that then gets sorted and built into table rows jsx data.

        let filteredData = headerFilterFunc(reportData, headerFilters, headerData);

        setActiveData(filteredData);
    }, [reportData, summaryData, headerFilters]);

    useEffect(() => {
        let interval;
        interval = setInterval(() => {
             setFilterCount(filterCount => filterCount + 1);
        }, 1000);
        if (filterCount <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_window_frequency",
                                procedure: "fetchall", reqType: "direct"}).then(data => {
                setFreqData(data);
            });
            setFilterCount(filterCount => 600);
        }
        return () => clearInterval(interval);
    }, [filterCount]);

    // This process applies sort and generates jsx for table body presentation, also handles pagination.
    useEffect(() => {
        if (activeData?.length > 0){
            let pRules = paginateData(activeData, page, perPage);
            setPRules(pRules);
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
            if (repType === "Detailed"){
                setFooter(() => (
                    <div>
                        <Pagination>
                            <PaginationItems setPage={setPage} page={page} beginDot={pRules.beginDot}
                                             endDot={pRules.endDot} pageMin={pRules.pageMin} pageMax={pRules.pageMax}
                                             max={pRules.max}/>
                        </Pagination>
                        <Button class={"btn btn-secondary fs-5 ms-4"} text={perPage} onClick={() => showModal("filtermodal")}/>
                    </div>
                ));
            }else{
                setFooter(() => <div style={{minWidth: "166px"}}></div>);
            }
            setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={false} writeAccess={false}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["deleteBtn"])}
                                tableHeaders={headerData} editModal={() => {}} modal={false} parentComponent={"Reports"}
                                dData={dData} checkboxlist={[]} modalType={""} unk={"a-"}
                                tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)}
                                setCheckboxId={() => {}} checkidkey={""} />);
            setBtnAvail(() => true);
        }else{
            setFooter(() => <div style={{minWidth: "166px"}}></div>);
        }
        setLink(() => {
            return {filename: `maintenance_report_${start}.csv`,
                headers: csvHeaders,
                data: reportData}
        });
    }, [activeData, sorter, page, perPage, reportData, repType]);

    const getNestedValue = useCallback((obj, path) => {
        if (obj == null || path == null) return "";
        const keys = String(path).split(".");
        let value = obj;
        for (const k of keys) {
            value = value?.[k];
            if (value === undefined || value === null) return "";
        }
        return value !== undefined && value !== null ? String(value) : "";
    }, []);

    const handleExportPDF = useCallback(() => {
        if (!reportData?.length || !csvHeaders?.length) return;
        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
        doc.setFontSize(12);
        doc.setTextColor("#0081c7");
        doc.text(`PalCare Maintenance Report: ${startDisplay}`, 10, 10, { align: "left"});
        const head = [csvHeaders.map((h) => h.label)];
        const body = reportData.map((row) =>
            csvHeaders.map((h) => Array.isArray(h.key)
                ? h.key.map((k) => getNestedValue(row, k)).join(" ")
                : getNestedValue(row, h.key))
        );
        autoTable(doc, {
            head,
            body,
            startY: 15,
            margin: { left: 8, right: 8 },
            styles: { fontSize: 7 },
            headStyles: { fillColor: [66, 139, 202], textColor: 255 },
            alternateRowStyles: { fillColor: [245, 245, 245] },
        });
        const startStr = start ? new Date(start).toISOString().slice(0, 10) : "start";
        const endStr = end ? new Date(end).toISOString().slice(0, 10) : "end";
        doc.save(`maintenance_report_${startStr}_${endStr}.pdf`);
    }, [reportData, csvHeaders, start, end, getNestedValue]);

    // This makes Export dropdown appear to download or not.
    useEffect(() => {
        if (reportData?.length > 0) {
            setCSVButtonHTML(() =>
                <div className={"d-inline-block"}>
                    <div className={"mx-2"}>
                        {btnAvail === true
                            ? <div className={"dropdown d-inline"}>
                                <button type={"button"} className={"btn btn-primary dropdown-toggle px-4 pt-2 fs-4 mb-2"}
                                        data-bs-toggle={"dropdown"} id={"exportDropdown"} data-bs-auto-close={"true"}
                                        style={{ height: "46px" }} aria-expanded={"false"}>
                                    <i className={"fe fe-download me-2"}/>Export
                                </button>
                                <div className={"dropdown-menu dropdown-menu-end"} aria-labelledby={"exportDropdown"}>
                                    <button className={"dropdown-item"}>
                                        <CSVLink {...csvLink} uFEFF={false}
                                             style={{ textDecoration: "none", color: "inherit" }}>
                                            <i className={"fe fe-file-text me-2"}/>Export as CSV
                                        </CSVLink>
                                    </button>
                                    <button type={"button"} className={"dropdown-item"} onClick={handleExportPDF}>
                                        <i className={"fe fe-file me-2"}/>Export as PDF
                                    </button>
                                </div>
                            </div>
                            : ""}
                    </div>
                </div>
            );
        } else {
            setCSVButtonHTML(() => "");
        }
    }, [csvLink, reportData?.length, btnAvail, handleExportPDF]);

    // This effect monitors fetching data on count expire, implemented for campus drop down
    // change to rerun report using count to rerun.
    useEffect(() => {
        let interval;
        interval = setInterval(() => {
             setCount(count => count + 1);
        }, 1000);
        if (status !== "init" && count <= 0){
            getReportData();
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let tmp = [];
        for (let i=0; i < freqData?.length; i++){
            tmp.push(
                <option key={`freq-option-${i}`} value={freqData[i]?.window_frequency_id}>{freqData[i]?.frequency_name}</option>
            );
        }
        setFreqOptions(() => tmp)
    }, [freqData]);

    useEffect(() => {
        if (status === "init") {
            setReportDisplay(
                <div>
                    <h4 className={"my-1 fs-3 px-4"}>No Report Loaded.</h4>
                </div>
            );
        }else if (status.toLowerCase() === "loading") {
            setReportDisplay(<div></div>);
        }else if ((repType.toLowerCase() === "detailed")){
            if (activeData?.length <= 0){
                setReportDisplay(
                    <div>
                        <h4 className={"my-1 fs-3 px-4"}>No data to show.</h4>
                    </div>
                );
            }else{
                setReportDisplay(
                    <>
                        <div className={"pt-1 pb-4 px-4 my-2"}>
                            <table className={"table table-sm table-white table-hover"}>
                                <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {tableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                    {tableRows}
                                </tbody>
                            </table>
                        </div>
                    </>
                );
            }
        } else {
            setReportDisplay(
                <div>
                    <h4 className={"my-1 fs-3 px-4"}>For report requested, please contact your customer success
                        manager.</h4>
                </div>
            );
        }
    }, [tableRows, summaryRows, status, repType, csvUrl]);

    useEffect(() => {
        let checkVar;
        checkVar = document.getElementById("sendForm");
        if (checkVar) {
            formCheck("sendForm", "downloadSubmit");
        }
    }, [reportDisplay])

    useEffect(() => {
        formCheck("addEmailForm", "addEmailSubmit");
    }, [addNewEmails, addCurEmails]);

    useEffect(() => {
        scheduleFormCheck("scheduleForm", "scheduleSubmit");
    }, [emailEntities]);

    function getReportData() {
        let startDisplay, endDisplay;
        handleSubmitActions("submitBtn", "loadSubmitBtn");

        // Sets status to loading and clears initial text display.
        setStatus(() => "Loading");
        startDisplay = formatDate(start);
        endDisplay = formatDate(end);
        setStartDisplay(() => startDisplay);
        setEndDisplay(() => endDisplay);

        setStartDatex(formatDateIso(start));
        setEndDatex(formatDateIso(end));
        setReportFilterTermsx(generateFilterTerms())

        // Conditional opportunity for different endpoints and reports.
        ApiRequester({
            reqEndpoint: "get-mysql-report",
            rep_type: "maintenanceReport",
            username: dData.username,
            campus_id: campusId,
            is_cloud: true,
            start_date: formatDateIso(start),
            end_date: formatDateIso(end),
            event_category_filter: "2",
            device_category_filter: devCatFilterList.join(","),
            area_type_filter: areaTypeFilterList.join(","),
            reason_filter: reasonFilterList.join(","),
            user_filter: userFilterList.join(","),
            event_type_filter: typeFilterList.join(","),
            resident_filter: resFilterList.join(","),
            resident_group_filter: residentGroupFilterList.join(","),
            area_filter: areaFilterList.join(","),
            area_group_filter: areaGroupFilterList.join(","),
            user_group_filter: userGroupFilterList.join(",")
        }).then(data => {
            handleSubmitActions("loadSubmitBtn", "submitBtn");
            if (data?.ErrorCode === 11) {
                toast.error("Report timed out, report too big, contact your customer success manager for assistance with large reports.");
            } else if (data?.ErrorCode === 10) {
                toast.error("An unknown error was encountered requesting report, please contact customer success if problem persists.");
            } else if (data?.ErrorCode === 12) {
                toast.error("Request unauthorized, service may be unavailable, please contact customer success if problem persists.");
            } else if (data?.overlimit) {
                setOverLimit(true);
                setCSVUrl(data?.url ? data?.url : "");
                toast.warn(`Report requested over 5000 events, details will need to be downloaded.`);
            } else {
                setOverLimit(false);
                setCSVUrl(data?.url ? data?.url : "");
            }
            setPage(1);
            let pRules = paginateData(data?.records ? data.records : [], 1, perPage);
            setPRules(() => pRules);
            setReportData(() => data?.records ? data.records : []);
            setCount(() => 600);
            setStatus(() => "");
        });
    }

    function filterSubmit(){
        // Submit function submitted by the pagination number of items per page modal.
        handleSubmitActions("filterSubmit", "loadFilterSubmit");
        setPerPage(tmpPerPage);
        dData.perPage = tmpPerPage;
        setPage(1);
        setSession(dData);
        formSuccess("Page parameters stored to session.", "filterSubmit",
            "loadFilterSubmit", "cancelFilterBtn");
    }

    function complexDelimDisplay(originText, newText){
        // Function used to build filter display inside the schedule modal pop up.
        // This function is generic takes lists recursively and builds appending comma delim strings.
        let ret;
        if (originText){
            if (newText){
                ret = `${originText}, ${newText}`;
            }else{
                ret = originText;
            }
        }else {
            ret = newText;
        }
        return ret;
    }

    function showScheduleModal(){
        // Function that preps and displays the pop up of the schedule modal.
        let filterText;
        document.getElementById("scheduleForm").reset();
        filterText = resFilterLabels.join(", ");
        filterText = complexDelimDisplay(filterText, areaFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, areaGroupFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, areaTypeFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, residentGroupFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, devCatFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, typeFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, userFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, userGroupFilterLabels.join(", "));
        filterText = complexDelimDisplay(filterText, reasonFilterLabels.join(", "));
        setEmailEntities(() => []);
        document.getElementById("filter-display").innerText = filterText?.length > 0 ? filterText : "None";
        formCheck("scheduleForm", "scheduleSubmit");
        showModal("schedulemodal");
    }

    function generateFilterTerms(){
        return {
            device_category_filter: {values: devCatFilterList.join(","), labels: devCatFilterLabels.join(",")},
            area_filter: {values: areaFilterList.join(","), labels: areaFilterLabels.join(",")},
            area_group_filter: {values: areaGroupFilterList.join(","), labels: areaGroupFilterLabels.join(",")},
            area_type_filter: {values: areaTypeFilterList.join(","), labels: areaTypeFilterLabels.join(",")},
            resident_filter: {values: resFilterList.join(","), labels: resFilterLabels.join(",")},
            resident_group_filter: {values: residentGroupFilterList.join(","), labels: residentGroupFilterLabels.join(",")},
            event_type_filter: {values: typeFilterList.join(","), labels: typeFilterLabels.join(",")},
            reason_filter: {values: reasonFilterList.join(","), labels: reasonFilterLabels.join(",")},
            user_filter: {values: userFilterList.join(","), labels: userFilterLabels.join(",")},
            user_group_filter: {values: userGroupFilterList.join(","), labels: userGroupFilterLabels.join(",")}
        }
    }

    function scheduleSubmit(){
        // Function called when submitting the scheduled report from schedule modal pop up.
        let payload, filterTerms, frequencyId, freqContainer, freqRate = [], nextSendTime, sendTime,
            pdf, csv, pdf2;
        handleSubmitActions("scheduleSubmit", "loadScheduleSubmit");
        filterTerms = generateFilterTerms();
        frequencyId = parseInt(document.getElementById("sch-frequency").value);
        if (frequencyId === 1){
            freqRate.push(1);
        }else if (frequencyId === 2){
            freqContainer = document.getElementsByName("sch-weekly-meta");
            for (let i=0; i < freqContainer?.length; i++){
                if (freqContainer[i].checked){
                    freqRate.push(freqContainer[i].value);
                }
            }
        }else if (frequencyId === 3){
            freqContainer = document.getElementsByName("sch-monthly-meta");
            for (let i=0; i < freqContainer?.length; i++){
                if (freqContainer[i].checked){
                    freqRate.push(freqContainer[i].value);
                }
            }
        }
        sendTime = document.getElementById("sch-sendTime").value;
        nextSendTime = calculateSendTime(frequencyId, freqRate, sendTime, parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0));
        pdf = document.getElementById("add-pdf")?.checked;
        pdf2 = document.getElementById("add-pdf2")?.checked;
        csv = document.getElementById("add-csv")?.checked;
        payload = [{
            campus_id: campusId,
            description: document.getElementById("sch-description").value,
            issue_freq_id: frequencyId,
            window_frequency_reference: freqRate.join(","),
            send_report_time: convertHHMMtoSec(sendTime),
            enabled: 1,
            report_type_id: 10,
            report_interval_id: rangeId,
            report_filter_terms: filterTerms,
            report_receiver: emailEntities.join(","),
            next_send_time: nextSendTime,
            pdf_summary: pdf ? 1 : 0,
            csv_details: csv ? 1 : 0,
            pdf_details: pdf2 ? 1 : 0
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "schedule_add", Payload: payload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Report schedule saved", "scheduleSubmit", "loadScheduleSubmit", "scheduleCancelBtn");
            } else {
                toast.error("Failed to schedule report.", "scheduleSubmit", "loadScheduleSubmit");
            }
        });
    }

    // The following section handles the email modal for schedule modal.

    function showEmailAddModal(output){
        // This function is called from the add modal when clicking on text or voice calling to set a list of phone
        // numbers to be saved with record add. This function triggers the modal to populate and builds the entity
        // list of phone numbers to add to the system.
        let tmp = [];
        for (let i=0; i < emailEntities?.length; i++){
            tmp.push(
                {id: uuidv4(), email: emailEntities[i]}
            );
        }
        setAddNewEmails(() => []);
        setAddCurEmails(() => tmp);
        swapModal("scheduleCancelBtn", "addemailmodal");
    }

    function setAddEmailItems(){
        // This function is triggered from the phone number add modal save which takes the current phone numbers
        // display items and then new numbers display items and sets those values into their appropriate output
        // entity holder text or voice.
        let tmp = [];
        handleSubmitActions("addEmailSubmit", "loadAddEmailSubmit");
        for (let i=0; i < addCurEmails?.length; i++){
            tmp.push(addCurEmails[i].email);
        }
        for (let i2=0; i2 < addNewEmails?.length; i2++){
            tmp.push(addNewEmails[i2].email);
        }
        setEmailEntities(() => tmp);
        document.getElementById("cancelAddEmailBtn").click();
        handleSubmitActions("loadAddEmailSubmit", "addEmailSubmit");
    }

    function scheduleFormCheck(formId, submitId){
        formCheck(formId, submitId);
        if (emailEntities?.length <= 0){
            let btn = document.getElementById(submitId)
            btn.classList.add("btn-danger");
            btn.classList.remove("btn-primary");
            btn.disabled = true;
        }
    }

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div>
                {scheduleable && <Button text={"Schedule"} style={{height: "46px"}} class={"btn btn-primary me-4 mb-2"}
                                         iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"} icon={true}
                                         iconSize={"tiny"} iconColor={"#FFFFFF"} iconType={"google"}
                                         iconName={"edit_calendar"} onClick={() => showScheduleModal()}/>}
                {csvButtonHTML}
                <Button id={"loadSubmitBtn"} text={""}
                        class={"btn px-4 pt-2 btn-toolbar btn-primary d-inline-block fs-3 mb-2 mx-2 d-none"}
                        spinner={true}/>
                <Button text={"Run"} icon={true} iconClass={"fe fe-refresh-cw pe-2"} id={"submitBtn"}
                        class={"btn px-3 btn-toolbar btn-primary d-inline-block fs-3 mb-2 mx-2"}
                        onClick={() => {
                            getReportData()
                        }}/>
            </div>
            <CampusDropDown campusId={campusId}
                            setCount={(item) => {
                                setCount(item);
                                setFilterCount(item);
                            }}
                            setCampusId={(item) => setCampusId(item)}
                            pageAction={(e) => {
                                if (dData?.campusData[campusId.toString()]?.is_cloud !== dData?.campusData[e.target.value]?.is_cloud){
                                    window.location.reload();
                                }
                            }}/>
        </div>
    );

    const tableHeaders = <TableHeaders checkbox={false} headerData={headerData} writeAccess={false}
                                       sortOrder={sorter.sortOrder} sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter}
                                       originData={reportData} headerFiltersOn={true} headerFilters={headerFilters}
                                       setHeaderFilters={setHeaderFilters} setPage={setPage} />

    const copyright = (
        <h6 className={"fs-5 pt-2"}>
            Copyright &copy; {getCurrentYear()}
        </h6>
    );
    const version = (
        <h6 className={"fs-5 pt-2"}>
            {import.meta.env.VITE_VERSION}
        </h6>
    );

    return (
        <>
            <Navigation/>
            <div className={"main-content"}>
                <Header preTitle={"Maintenance Reports 5.0"} Title={"Active Maintenance"} content={headerContent}/>
                <div className={"container-fluid mt-4"}>
                    {reportDisplay}
                    <div className={"footer-spacer"}>

                    </div>
                </div>
                <div className={"modal fade"} id={"schedulemodal"} data-bs-backdrop={"static"}
                     data-bs-keyboard={"false"}
                     tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title text-capitalize"} id={"staticBackdropLabel"}>Schedule
                                    Report</h2>
                                <button type={"button"} className={"btn-close"} id={"scheduleClose"}
                                        data-bs-dismiss={"modal"} aria-label={"Close"}/>
                            </div>
                            <form id={"scheduleForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div>
                                        <h4 className={"d-inline-block align-top"} style={{minWidth: "125px"}}>Report
                                            Type:</h4>
                                        <h4 className={"d-inline-block text-capitalize"} id={"report-display"}
                                            style={{
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                overflow: "hidden",
                                                maxWidth: "350px"
                                            }}>Maintenance</h4>
                                    </div>
                                    <div className={"mb-3"}>
                                        <h4 className={"d-inline-block"} style={{minWidth: "125px"}}>Report Range:</h4>
                                        <h4 className={"d-inline-block"}>{rangeName}</h4>
                                    </div>
                                    <div className={"mb-3"}>
                                        <h4 className={"d-inline-block align-top"} style={{minWidth: "125px"}}>Filter
                                            Params:</h4>
                                        <h4 className={"d-inline-block"} id={"filter-display"}
                                            style={{
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                overflow: "hidden",
                                                maxWidth: "350px"
                                            }}></h4>
                                    </div>
                                    <div className={"d-inline-block"}>
                                        <div className={"form-check"}>
                                            <label htmlFor={"add-pdf"}>Add PDF Attachment (Summary)</label>
                                            <input id={"add-pdf"} defaultChecked={false}
                                                   className={"form-check-input"} type={"checkbox"}/>
                                        </div>
                                        <div className={"form-check"}>
                                            <label htmlFor={"add-pdf2"}>Add PDF Attachment (Details)</label>
                                            <input id={"add-pdf2"} defaultChecked={false}
                                                   className={"form-check-input"} type={"checkbox"}/>
                                        </div>
                                        <div className={"form-check"}>
                                            <label htmlFor={"add-csv"}>Add CSV Attachment (Details)</label>
                                            <input id={"add-csv"} defaultChecked={false}
                                                   className={"form-check-input"} type={"checkbox"}/>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className={"form-floating mb-3"}>
                                        <input type={"text"} className={"form-control"} id={"sch-description"}
                                               onKeyUp={() => scheduleFormCheck("scheduleForm", "scheduleSubmit")}
                                               required={true} pattern={"^[0-9a-zA-Z_@\\- ]+$"}/>
                                        <label htmlFor={"sch-description"}>Description</label>
                                    </div>
                                    <div className={"d-flex justify-content-around"}>
                                        <div className={"form-floating mb-3 me-3 w-75"}>
                                            <select className={"form-select"} required={true} id={"sch-frequency"}
                                                    defaultValue={""}
                                                    onChange={(e) => {
                                                        if (e.target.value.toString() === "1") {
                                                            document.getElementById("sch-weekly").classList.add("d-none");
                                                            document.getElementById("scheduler-container").classList.add("d-none");
                                                            document.getElementById("sch-monthly").classList.add("d-none");
                                                        } else if (e.target.value.toString() === "2") {
                                                            document.getElementById("sch-weekly").classList.remove("d-none");
                                                            document.getElementById("scheduler-container").classList.remove("d-none");
                                                            document.getElementById("sch-monthly").classList.add("d-none");
                                                        } else {
                                                            document.getElementById("sch-monthly").classList.remove("d-none");
                                                            document.getElementById("scheduler-container").classList.remove("d-none");
                                                            document.getElementById("sch-weekly").classList.add("d-none");
                                                        }
                                                        scheduleFormCheck("scheduleForm", "scheduleSubmit");
                                                    }}>
                                                <option value={""} disabled={true}></option>
                                                {freqOptions}
                                            </select>
                                            <label htmlFor={"sch-frequency"}>Delivery Rate</label>
                                        </div>
                                        <div className={"form-floating mb-3"}>
                                            <input type={"time"} className={"form-control"} id={"sch-sendTime"}
                                                   required={true} step={"300"} min={"00:00"} max={"23:59"}
                                                   onFocus={(e) => {
                                                       e.target.showPicker();
                                                   }}
                                                   onBlur={(e) => {
                                                       if (!e.target.checkValidity()) {
                                                           e.target.stepUp();
                                                       }
                                                       scheduleFormCheck("scheduleForm", "scheduleSubmit");
                                                   }}/>
                                            <label htmlFor={"sch-sendTime"}>Time of Day</label>
                                        </div>
                                    </div>
                                    <fieldset className={"border py-3 px-3 mt-4 d-none"} style={{borderRadius: "6px"}}
                                              id={"scheduler-container"}>
                                        <legend className={"fs-3 px-3 w-auto mb-0 legend"} style={{
                                            backgroundColor: "#FFFFFF",
                                            position: "relative",
                                            bottom: "26px"
                                        }}>Delivery Schedule
                                        </legend>
                                        <div id={"sch-weekly"} className={"d-none"}>
                                            <ul style={{columns: 3, listStyle: "none", columnGap: "30px"}}
                                                className={"float-start"}>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-0"}>Monday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-0"}
                                                               value={0}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-1"}>Tuesday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-1"}
                                                               value={1}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-2"}>Wednesday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-2"}
                                                               value={2}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-3"}>Thursday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-3"}
                                                               value={3}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-4"}>Friday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-4"}
                                                               value={4}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-5"}>Saturday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-5"}
                                                               value={5}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-weekly-meta-6"}>Sunday</label>
                                                        <input name={"sch-weekly-meta"} id={"sch-weekly-meta-6"}
                                                               value={6}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div id={"sch-monthly"} className={"d-none"}>
                                            <ul style={{columns: 4, listStyle: "none", columnGap: "30px"}}
                                                className={"float-start"}>
                                                {Array.from(range(1, 30)).map((i) => {
                                                    return (
                                                        <li key={`monthly-rate-item-${i}`}>
                                                            <div className={"form-check"}>
                                                                <label htmlFor={`sch-monthly-meta-${i}`}>{i}</label>
                                                                <input name={"sch-monthly-meta"}
                                                                       id={`sch-monthly-meta-${i}`} value={i}
                                                                       defaultChecked={false}
                                                                       className={"form-check-input"}
                                                                       type={"checkbox"}/>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                                <li>
                                                    <div className={"form-check"}>
                                                        <label htmlFor={"sch-monthly-meta-0"}>Last Day</label>
                                                        <input name={"sch-monthly-meta"} id={"sch-monthly-meta-0"}
                                                               value={0}
                                                               defaultChecked={false}
                                                               className={"form-check-input"} type={"checkbox"}/>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </fieldset>
                                    <hr className={"my-5"}/>
                                    <div className={"d-inline-block"} id={"add-email-icon"}>
                                        <Button text={"Set Emails"} class={"btn btn-primary align-top me-4"}
                                                id={"add-email-groups"} onClick={() => {
                                            showEmailAddModal()
                                        }}/>
                                        <fieldset className={"border py-3 px-3 d-inline-block"}
                                                  style={{borderRadius: "6px", minWidth: "200px"}}>
                                            <legend className={"legend-3"}>Emails</legend>
                                            <ul className={"ps-3"} style={{listStyle: "none"}}>
                                                {emailEntities?.length > 0
                                                    ? emailEntities.map((email) => {
                                                        return (
                                                            <li key={`email-display-${email}`}>{email}</li>
                                                        );
                                                    })
                                                    : <li>None</li>
                                                }
                                            </ul>
                                        </fieldset>
                                    </div>
                                </div>
                                <div className={"modal-footer"}>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary"} id={"scheduleCancelBtn"}
                                                data-bs-dismiss={"modal"}>Cancel
                                        </button>
                                        <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                                spinner={true} text={"Loading"} id={"loadScheduleSubmit"}/>
                                        <button type={"button"} className={"btn btn-primary ms-3"} id={"scheduleSubmit"}
                                                onClick={() => scheduleSubmit()}>Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"addemailmodal"} data-bs-backdrop={"static"}
                     data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title text-capitalize"} id={"staticBackdropLabel"}>Set Emails</h2>
                                <button type={"button"} className={"btn-close"} id={"addEmailClose"}
                                        data-bs-dismiss={"modal"} aria-label={"Close"}/>
                            </div>
                            <form id={"addEmailForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div className={"list-group-item"}>
                                        <Button type={"button"} class={"btn btn-primary mb-3"} text={"New Email"}
                                                onClick={() => {
                                                    setAddNewEmails((prevState) => {
                                                        return [...prevState, {id: uuidv4(), email: ""}]
                                                    });
                                                    formCheck("addEmailForm", "addEmailSubmit");
                                                }}/>
                                        {addNewEmails.map((item) => {
                                            return (
                                                <div key={`add-new-email-item${item.id}`}>
                                                    <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                       onClick={() => {
                                                           setAddNewEmails((prevState) => {
                                                               return prevState.filter(i => i.id !== item.id);
                                                           });
                                                       }}></i>
                                                    <div className={"form-floating d-inline-block w-75 mb-3 mx-3"}>
                                                        <input type={"text"} name={"add-email-input"}
                                                               className={"form-control"}
                                                               id={`add-new-email-${item.id}`}
                                                               onKeyUp={(e) => {
                                                                   setAddNewEmails((prevState) => {
                                                                       return prevState.map((i) => {
                                                                           if (i.id === item.id) {
                                                                               return {id: i.id, email: e.target.value}
                                                                           }
                                                                           return i
                                                                       });
                                                                   })
                                                                   formCheck("addEmailForm", "addEmailSubmit");
                                                               }} required={true}
                                                               pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$"}
                                                               defaultValue={item.email}/>
                                                        <label htmlFor={`tmp-email-${item.id}`}>Email Address</label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <hr/>
                                    <div className={"list-group-item"}>
                                        {addCurEmails.map((item) => {
                                            return (
                                                <div key={`add-stored-email-${item.id}`}>
                                                    <i className={"fe fe-trash as-btn d-inline-block red-hover"}
                                                       onClick={() => {
                                                           setAddCurEmails((prevState) => {
                                                               return prevState.filter(i => i?.id !== item.id);
                                                           });
                                                       }}></i>
                                                    <div className={"form-floating d-inline-block w-75 mb-3 mx-3"}>
                                                        <input type={"text"} name={"add-email-input"}
                                                               className={"form-control"}
                                                               id={`add-tmp-email-${item.id}`}
                                                               required={true}
                                                               pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$"}
                                                               value={item.email} readOnly={true}/>
                                                        <label htmlFor={`add-tmp-email-${item.id}`}>Email
                                                            Address</label>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                <div className={"modal-footer"}>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary"} id={"cancelAddEmailBtn"}
                                                onClick={() => {
                                                    swapModal("addEmailClose", "schedulemodal")
                                                }}>Cancel
                                        </button>
                                        <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                                spinner={true} text={"Loading"} id={"loadAddEmailSubmit"}/>
                                        <button type={"button"} className={"btn btn-primary ms-3"} id={"addEmailSubmit"}
                                                onClick={() => setAddEmailItems()}>Set
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Footer left={copyright} right={version} center={footer}/>
                <PerPageModal filterSubmit={() => filterSubmit()} tmpPerPage={tmpPerPage}
                              setTmpPerPage={(sudocode) => setTmpPerPage(sudocode)}
                              setPage={(sudocode) => setPage(sudocode)}/>
                <Suspense fallback={"Loading..."}>
                    <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                    autoClose={10000} closeOnClick={true}/>
                </Suspense>
            </div>
        </>
    );
};

export default MaintenanceCloudReports;